import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../../environments/environment';

@Pipe({name: 'image'})
export class ImagePipe implements PipeTransform {
  transform(path: string): string {
    return environment.api + '/' +  path;
  }
}
